import PagerService from "../services/pager";

type PagerConfProps = { onChange: () => void }

type ChangeSelectEvent = React.ChangeEvent<HTMLSelectElement>;

const PAGERS_NB_PER_PAGES = [-1, 20, 50, 100, 200, 500];

export default function PagerConf({onChange}: PagerConfProps) {
    
    function changePagerSize(nbPerPage: string) {
        const perPage = Number(nbPerPage)
        if (!isNaN(perPage)) {
            PagerService.changePerPage(perPage)
            if (onChange) {
                onChange();
            }
        }
    }

    return (
        <>
            <select
                onChange={(event: ChangeSelectEvent) => changePagerSize(event.target.value)}
                value={PagerService.getPageSize()}
                >
                { PAGERS_NB_PER_PAGES.map(nbPerPage =>
                    <option key={nbPerPage} value={nbPerPage}>
                        { nbPerPage === -1
                            ? 'Pas de pagination'
                            : nbPerPage + ' par page'
                        }
                    </option>
                )}
            </select>
        </>
    );
}
